/**
 * @ngdoc service
 * @name kareo.ui.shared.assets:PatientCreateModalService
 * @description
 * Launch patient create modal
 *
 * @example
 <example module="patientCreateDemo">
 <file name="index.html">
 <div ng-controller="PatientCreateDemoCtrl" class="kareo" >
 <button ng-click="createPatient()">Create Patient</button>
 <patient-create-modal/>
 </div>
 </file>
 <file name="demo.js">
 var app = angular.module('patientCreateDemo', ['kareo.ui.shared.directives.patient-create']);

 app.controller('PatientCreateDemoCtrl', ['$scope', 'PatientCreateModalService', function($scope, PatientCreateModalService){
       $scope.createPatient = function(){
        PatientCreateModalService.launch();
       };
     }]);
 </file>
 </example>
 */

angular
  .module('kareo.ui.shared.directives.k-patient-check-eligibility.services', [])
  .factory('PatientEligibilityService', [
    '$http', function ($http) {
      var dataService = {};
      const billingProfileUIInsuranceApi = '/billing-profiles-ui/api/Insurance';
      const enrollmentsUIInsuranceCompanyApi = '/enrollments-ui/api/InsuranceCompany';
      const getProviders = 'providers';

      dataService.getProviders = function () {
        return $http
            .get(billingProfileUIInsuranceApi + '/' + getProviders)
            .then((response) => {
              return response;
            });
      };

      dataService.checkEligibility = function (request) {
        // modify the patient data to only submit things we will check for duplicates on

        var checkEligibility = 'checkEligibilitySummary';
        return $http
            .post(billingProfileUIInsuranceApi + '/' + checkEligibility, request)
            .then((response) => {
              return response.data;
            });
      };


      dataService.getPayerDetailsByPayerIds = function(providerId, providerNPI, clearingHousePayerIds) {
          const REQUEST_URL = enrollmentsUIInsuranceCompanyApi + '/GetPracticePayerListByIds';
          const data = {
              pmProviderId: providerId,
              group: !providerId,
              providerNPI,
              clearingHousePayerIds
          };

          return $http
              .post(REQUEST_URL, data)
              .then((response) => {
                  return response.data;
              });
      };

      return dataService;
    }]);
